import { render, staticRenderFns } from "./StaffList.vue?vue&type=template&id=2d261852&"
import script from "./StaffList.vue?vue&type=script&lang=js&"
export * from "./StaffList.vue?vue&type=script&lang=js&"
import style0 from "./StaffList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports